import AliasEqualsModel from '../AliasEqualsModel';
const attrName = 'vehicle.calculatedAlerts';
export default AliasEqualsModel.create(attrName);